import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Button, Icon, Segment, Table, Input, Divider } from 'semantic-ui-react';
import qs from 'qs';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { getTrackingBioLink, getTrackingStoryLink } from '../../utils/get-tracking-links';

const inputStyle = {
  fontSize: 11,
};

class LinkTracking extends Component {
  constructor() {
    super();
    this.state = {
      bioCopied: false,
      storyCopied: false,
    };
  }

  render() {
    const {
      baseTrackingUrl,
      campaignId,
      hashtags,
      instagram,
    } = this.props;

    const {
      bioCopied, storyCopied,
    } = this.state;

    const bioParams = getTrackingBioLink({
      campaignId,
      hashtags,
      instagram,
    });

    const storyParams = getTrackingStoryLink({
      campaignId,
      hashtags,
      instagram,
    });

    const bioLink = `${baseTrackingUrl}?${bioParams}`;
    const storyLink = `${baseTrackingUrl}?${storyParams}`;

    return (
      <Segment>
        <h3>Link tracking</h3>
        <Divider />
        <Table>
          <Table.Row>
            <Table.Cell width={2}>Bio Link</Table.Cell>
            <Table.Cell width={14}>
              <Input
                labelPosition="right"
                label={
                  <CopyToClipboard
                    text={bioLink}
                    onCopy={() => this.setState({ bioCopied: true, storyCopied: false })}
                  >
                    <Button icon={bioCopied ? 'checkmark' : 'copy'} color="pink" />
                  </CopyToClipboard>
                }
                fluid
                value={bioLink}
              />
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell width={2}>Story Link</Table.Cell>
            <Table.Cell width={14}>
              <Input
                as="div"
                labelPosition="right"
                label={
                  <CopyToClipboard
                    text={storyLink}
                    onCopy={() => this.setState({ bioCopied: false, storyCopied: true })}
                  >
                    <Button icon={storyCopied ? 'checkmark' : 'copy'} color="pink" />
                  </CopyToClipboard>
                }
                fluid
                value={storyLink}
              />
            </Table.Cell>
          </Table.Row>
        </Table>
      </Segment>
    );
  }
}

LinkTracking.propTypes = {
  baseTrackingUrl: PropTypes.string.isRequired,
  campaignId: PropTypes.string.isRequired,
  hashtags: PropTypes.string.isRequired,
};

export default LinkTracking;



/** WEBPACK FOOTER **
 ** ./src/components/link-tracking/index.js
 **/